import { loginSuccess } from './../actions/user.action';
import { confirmError } from './../actions/register.action';
import { AccessToken } from './../models/user.model';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import {
  confirm,
  loadForm,
  loadFormSuccess,
  pay,
  payError,
  paySuccess,
  validateForm,
  validateFormError,
  validateFormSuccess,
} from '../actions/register.action';
import { UserService } from '../services/user.service';
import { IStepConfirmValidation, RegisterReceiptData } from '../models/register.model';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class RegisterEffect {
  loadForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadForm),
      exhaustMap(({ data }) => {
        return of(loadFormSuccess({ data }));
      })
    )
  );
  validateForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(validateForm),
      switchMap(({ data }) => this.userService.validateEmailAddress(data)),
      exhaustMap((response: IStepConfirmValidation) => {
        if (response.hasOwnProperty('success') && response.success === true) {
          return of(
            validateFormSuccess({
              data: {
                step: 2,
              },
            }),
          );
        }

        return of(
          validateFormError({
            error: response.errors.email,
          }),
        );
      })
    )
  );
  payEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(pay),
      switchMap(({ userData, data }) =>
        this.userService.payFee(userData, data).pipe(
          switchMap((res: RegisterReceiptData) =>
            res.success === false
              ? of(payError({ error: res.errors }))
              : of(paySuccess({ paymentData: res }))
          ),
          catchError((err: HttpErrorResponse) =>
            of(payError({ error: err.error }))
          )
        )
      )
    )
  );
  confirmEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(confirm),
      switchMap(({ token }) => this.userService.confirm(token)),
      switchMap((res: AccessToken | null) =>
        of(loginSuccess({ accessToken: res }))
      ),
      catchError(err => {
        let error = err;

        return of(confirmError({ error }));
      })
    )
  );

  constructor(
    private actions$: Actions,
    private userService: UserService,
  ) {
  }
}
